import template from './sw-cms-block-image-three-column.html.twig';
import './sw-cms-block-image-three-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
